import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import { searchSuppliersAsync } from "../../../../redux/features/supplier.features";
import SupplierForm from "../../../suppliers/SupplierForm";
import { FaPlusSquare } from "react-icons/fa";

export default function SupplierField({
  selectedSupplierId,
  onAddSupplier,
  isInvalid,
}) {
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const { suppliers, searchResults, searching } =
    useSelector((state) => state.supplierReducer);

  const dispatch = useDispatch();

  const handleSearch = (query) => {
    dispatch(searchSuppliersAsync(query));
  };

  const handleSupplierSelect = (selected) => {
    if (selected.length > 0) {
      setSelectedSupplier(selected);
      onAddSupplier(selected[0]);
    }
  };

  useEffect(() => {
    if (selectedSupplierId) {
      const all = [...(suppliers || []), ...(searchResults || [])];
      const found = all.find((i) => i._id === selectedSupplierId);
      if (found) setSelectedSupplier([found]);
    } else {
      setSelectedSupplier([]);
    }
  }, [selectedSupplierId, suppliers, searchResults]);

  const handleSuccess = (newSupplier) => {
    if (newSupplier) {
      setSelectedSupplier([newSupplier]);
      onAddSupplier(newSupplier);
    }
    setShowModal(false);
  };

  return (
    <>
      <div className="supplier-field-wrapper d-flex align-items-center">
        <div className="flex-grow-1">
          <AsyncTypeahead
            id="supplier-search"
            positionFixed   // 🔥 CRITICAL FIX
            isLoading={searching}
            onSearch={handleSearch}
            options={searchResults}
            defaultOptions={suppliers}
            labelKey="business_name"
            minLength={2}
            selected={selectedSupplier}
            onChange={handleSupplierSelect}
            isInvalid={isInvalid}
            placeholder="SEARCH SUPPLIER..."
            inputProps={{
              className: "supplier-dark-input",
            }}
            renderMenuItemChildren={(option) => (
              <div className="supplier-item">
                <div className="supplier-name">
                  {option.business_name}
                </div>
                <div className="supplier-meta">
                  TEL: {option.contact_info?.contact_number || "N/A"}
                </div>
              </div>
            )}
          />
        </div>
        <button
          type="button"
          onClick={() => setShowModal(true)}
          title="Add Supplier"
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: 'none',
            color: 'white',
            borderRadius: '4px',
            height: '36px',
            width: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '8px'
          }}
        >
          <FaPlusSquare size={18} />
        </button>
      </div>

      <Modal
        size="xl"
        show={showModal}
        onHide={() => setShowModal(false)}
        contentClassName="supplier-dark-modal"
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title className="text-white">
            Add Supplier
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SupplierForm
            savedCompleted={handleSuccess}
            setShow={setShowModal}
            isEdit={false}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}